/**
 * 1stbuddha — accordion.js
 *
 * <accordion-list> toggles .accordion items inside it. Each item is
 *   <div class="accordion" data-open="false">
 *     <h3><button class="accordion__trigger" aria-expanded="false" aria-controls="id">…</button></h3>
 *     <div class="accordion__panel" id="id" role="region" aria-labelledby="…">
 *       <div class="accordion__inner">…</div>
 *     </div>
 *   </div>
 * The panel animates grid-template-rows 0fr → 1fr (component-accordion.css).
 * Add the `single` attribute to keep only one item open at a time.
 */
(() => {
  if (customElements.get('accordion-list')) return;

  class AccordionList extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('.accordion__trigger');
        if (!trigger || !this.contains(trigger)) return;
        this.toggle(trigger.closest('.accordion'), trigger.getAttribute('aria-expanded') !== 'true');
      });
    }

    toggle(item, open) {
      if (!item) return;
      if (open && this.hasAttribute('single')) {
        this.querySelectorAll('.accordion[data-open="true"]').forEach((other) => {
          if (other !== item) this.toggle(other, false);
        });
      }
      item.dataset.open = String(open);
      item.querySelector('.accordion__trigger')?.setAttribute('aria-expanded', String(open));
    }
  }

  customElements.define('accordion-list', AccordionList);
})();
